import merge from 'deepmerge';

import common from './common';
import de from './de/customer.json';
import deAT from './de-AT/customer.json';
import deCH from './de-CH/customer.json';
import en from './en/customer.json';
import fr from './fr/customer.json';
import frCH from './fr-CH/customer.json';

const customer = {
  fr: fr.customer,
  en: en.customer,
  de: de.customer,
  'fr-CH': merge(fr.customer, frCH.customer || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-CH': merge(de.customer, deCH.customer || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-AT': merge(de.customer, deAT.customer || {}),
};

export default merge(common, customer);
